import React from "react";
import { Boxes } from "lucide-react";
import { OrderProductCheckIn } from "src/types";
import { ProductCheckInTable } from "src/components/tables";

interface OrderProductCheckInsSectionProps {
  orderProducts: OrderProductCheckIn[];
}

const OrderProductCheckInsSection: React.FC<OrderProductCheckInsSectionProps> = ({ orderProducts }) => {
  if (!orderProducts.length) {
    return null;
  }

  return (
    <section className="rounded-2xl border border-secondary-200 bg-white p-6 shadow-soft sm:p-8">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <div className="rounded-xl bg-secondary-100 p-3 text-secondary-900">
            <Boxes className="h-5 w-5" />
          </div>

          <div>
            <h2 className="text-xl font-semibold text-secondary-900">Product Check-ins</h2>
            <p className="mt-1 text-sm text-secondary-600">
              Detailed log of received purchase order items, quantities, and any discrepancies flagged during intake.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <ProductCheckInTable orderProductCheckIns={orderProducts} />
      </div>
    </section>
  );
};

export { OrderProductCheckInsSection };
